// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleCheckbox_container__6_1e6","label":"SimpleCheckbox_label__MGQbD","checkmark":"SimpleCheckbox_checkmark__ZaHR_"};